import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=72fd6f98&scoped=true&"
import script from "./Bubble.vue?vue&type=script&lang=js&"
export * from "./Bubble.vue?vue&type=script&lang=js&"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=72fd6f98&prod&lang=css&"
import style1 from "./Bubble.vue?vue&type=style&index=1&id=72fd6f98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd6f98",
  null
  
)

export default component.exports